import { createFileRoute } from '@tanstack/react-router'

import { DocumentUploadPage } from '@/components/organisms/document-upload/document-upload-page'

/**
 * Uploading a document into an errand. Renders the exact same page as /documents/upload — the
 * errand only changes where the document is attached and where the page returns to, both of which
 * the component already handles from `errandId`.
 *
 * The `$id_` suffix un-nests this from the `/errands/$id` route: that route is the errand detail
 * page, not a layout, so nesting under it would render the detail page and never reach this one.
 */
const ErrandUploadRoute = () => {
  const { id } = Route.useParams()

  return <DocumentUploadPage errandId={id} />
}

export const Route = createFileRoute('/_authenticated/errands/$id_/upload')({
  component: ErrandUploadRoute,
})
